module.exports = function(vars) {
var __t, __p = '';
__p += '<div class="player-overlay-segment">\n<!--\n	<div class="col-md-2 col-sm-2 col-xs-3 player-thumbnail-wrapper">\n		<img class=" img-thumbnail player-thumbnail" src="" alt=""/>\n	</div>\n-->\n	<div class="row shady-row">\n		<div class="col-md-12">\n			<span class="label label-danger live-badge watch-live-broadcast">LIVE</span><h1 class="player-header player-title church-name"></h1>\n			<!-- <h2 class="player-description church-description"></h2>\n			<div class="player-countdown countdown-segment"></div> -->\n		</div>\n	</div>\n</div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/home-overlay.ejs